import { PrimaryGeneratedColumn, Column, JoinColumn, ManyToOne, OneToMany, Entity, Index } from 'typeorm';
import { LicenseRequest, User } from '.';

@Entity()
export class StripeOrder {
	@PrimaryGeneratedColumn() id: number;

	@Index()
	@Column('varchar')
	paymentIntentId: string;

	@Column('varchar') totalAmount: string;

	@OneToMany(() => LicenseRequest, (licenseRequest) => licenseRequest.stripeOrder)
	@JoinColumn()
	licenseRequests: LicenseRequest[];

	@Column('int') userId: number;
	@ManyToOne(() => User)
	@JoinColumn()
	user: User;

	@Column('tinyint', { default: false })
	isPaid: boolean;

	@Column('tinyint', { default: false })
	isComplete: boolean;

	@Column('datetime') createdAt: Date;
}
